import React from "react";
import './Footer.css';

const Footer=()=>{
    return<>
    <footer className="bg-light text-center text-white foot">
  <div>
    <section  style={{backgroundColor: "rgba(0, 0, 0, 0.2)"}}>
    <div class="social-container">
    <ul class="social-icons">
        
        <li><a href="#"><i class="fa fa-code"></i></a></li>
        <li><a href="https://www.linkedin.com/in/shubhra-srivastava/"><i class="fa fa-linkedin"></i></a></li>
        <li><a href="https://github.com/Shubhi-22"><i class="fa fa-github"></i></a></li>
        </ul>
    
    <div className="text-center p-3">
    © 2023 Copyright:
    <a className="text-white" href="https://mdbootstrap.com/">Shubhra Srivastava</a>
  </div>
  
  </div>
    </section>
  </div>

  
</footer>
    </>
}

export default Footer;